import { useLanguage } from "@/i18n/LanguageContext";
import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";

export default function PrivacyPage() {
  const { t } = useLanguage();
  const p = t.privacy;
  return (
    <main className="pt-28 pb-20" data-testid="privacy-page">
      <Seo page="privacy" title={p.seoTitle} description={p.seoDesc} />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="text-xs font-mono uppercase tracking-[0.25em] text-terra mb-4">{p.eyebrow}</p>
          <h1 className="font-serif text-4xl sm:text-5xl tracking-tight mb-12" data-testid="privacy-title">{p.title}</h1>
        </Reveal>
        <div className="space-y-8" data-testid="privacy-sections">
          {p.sections.map((s, i) => (
            <Reveal key={i} delay={0.05}>
              <section data-testid={`privacy-section-${i}`}>
                <h2 className="font-serif text-xl font-semibold mb-2">{s.h}</h2>
                {s.p && <p className="text-sm sm:text-base text-ink/75 leading-relaxed">{s.p}</p>}
                {s.items && (
                  <ul className="list-disc pl-5 space-y-2 text-sm sm:text-base text-ink/75 leading-relaxed">
                    {s.items.map((it, j) => (
                      <li key={j}>{it}</li>
                    ))}
                  </ul>
                )}
              </section>
            </Reveal>
          ))}
        </div>
      </div>
    </main>
  );
}
